import { getAxiosInstance } from "../../../../api";

export const getBranchCurrencyEditData = async (branch_currency_id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(
      `/admin/branch/currency/edit?branch_currency_id=${branch_currency_id}`
    );
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
export const updatePriority = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/branch/currency/set-order`,body);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
